// extracted by mini-css-extract-plugin
export default {"root":"pfZnW+R","content":"O0jYewA"};